import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import { useRegisterContext } from "../../Contexts/RegisterContext";
import { forgerockErrors } from "../../utilities/configurations";
import ExpiredOtpModal from "../../Components/ExpiredOtpModal";
import { FRAuth, StepType } from "@forgerock/javascript-sdk";
import ErrorModal from "../../Components/ErrorModal";
import { CircularProgress } from "@mui/material";
import OtpField from "../../Components/OtpField";
import Button from "../../Components/Button";
import { useState, useEffect } from "react";
import dayjs from "dayjs";
import { server_error_message, server_error_title } from "../../utilities/values";

function ActivateVerifyOTP() {
  const {
    setShowExpiredOtpModal,
    showExpiredOtpModal,
    setConfigRestarted,
    setDisplayAlert,
    setAlertMessage,
    setJourneyStep,
    setAlertTitle,
    mobileNumber,
    alertMessage,
    handleVerify,
    displayAlert,
    journeyStep,
    resetValues,
    alertTitle,
    handleBack,
    isLoading,
    navigate,
    setOtp,
    otp,
  } = useRegisterContext();

  const [counter, setCounter] = useState(180);
  const [isResending, setIsResending] = useState(false);

  useEffect(() => {
    const timer =
      counter > 0 &&
      setInterval(() => setCounter((prevCounter) => prevCounter - 1), 1000);
    return () => clearInterval(timer);
  }, [counter]);

  const formatTime = (seconds) =>
    dayjs().startOf("day").add(seconds, "seconds").format("mm:ss");

  const handleClose = () => {
    setDisplayAlert(false);
    setAlertTitle("");
    setAlertMessage("");
    navigate("/activate/choose-membership", { replace: true });
  };

  const resendOtp = async () => {
    try {
      let journey_obj = JSON.parse(JSON.stringify(journeyStep));
      journey_obj.callbacks[0].payload.input[0].value = "RESEND0";
      journey_obj.payload.callbacks[0].input[0].value = "RESEND0";

      const nextStep = await FRAuth.next(journey_obj);
      switch (nextStep.type) {
        case StepType.Step:
          setJourneyStep(nextStep);
          setCounter(180);
          break;
        case StepType.LoginFailure:
          {
            const detail = nextStep.getDetail();
            const errorReason = nextStep.getReason();
            const errorMessage = nextStep.getMessage();
            if (detail?.errorCode === "110") {
              setDisplayAlert(true);
              setAlertTitle(errorReason);
              setAlertMessage(errorMessage);
            } else {
              setDisplayAlert(true);
              setAlertTitle("Error");
              setAlertMessage(
                forgerockErrors[detail?.failureUrl] || forgerockErrors["SWW"]
              );
            }
            resetValues();
            setConfigRestarted(true);
          }
          break;
      }
    } catch (err) {
      setDisplayAlert(true);
      setAlertTitle(server_error_title);
      setAlertMessage(server_error_message);
      resetValues();
      setConfigRestarted(true);
      console.log(err);
    }
  };

  const handleOtpChange = (newOtp) => {
    setAlertMessage("");
    setOtp(newOtp);
  };

  const handleKeyDown = (event, callback) => {
    if (event.key === "Enter" || event.key === " ") {
      callback();
    }
  };

  const handleResend = async () => {
    setIsResending(true);
    let journey_obj = JSON.parse(JSON.stringify(journeyStep));
    journey_obj.callbacks[1].payload.input[0].value = 0;
    journey_obj.payload.callbacks[1].input[0].value = 0;
    try {
      const nextStep = await FRAuth.next(journey_obj);
      switch (nextStep.type) {
        case StepType.Step:
          setJourneyStep(nextStep);
          setOtp("");
          setCounter(180);
          break;
        case StepType.LoginFailure:
          {
            const detail = nextStep.getDetail();
            const errorReason = nextStep.getReason();
            const errorMessage = nextStep.getMessage();
            if (detail?.errorCode === "110") {
              setDisplayAlert(true);
              setAlertTitle(errorReason);
              setAlertMessage(errorMessage);
            } else {
              setDisplayAlert(true);
              setAlertTitle("Error");
              setAlertMessage(
                forgerockErrors[detail?.failureUrl] || forgerockErrors["SWW"]
              );
            }
            resetValues();
            setConfigRestarted(true);
          }
          break;
      }
    } catch (err) {
      setDisplayAlert(true);
      setAlertTitle(server_error_title);
      setAlertMessage(server_error_message);
      resetValues();
      setConfigRestarted(true);
      console.log(err);
    } finally {
      setIsResending(false);
      setShowExpiredOtpModal(false);
    }
  };

  const handleCancelResend = () => {
    resetValues();
    setConfigRestarted(true);
    setShowExpiredOtpModal(false);
    navigate("/activate/choose-membership", { replace: true });
  };

  return (
    <div className="flex flex-col min-h-screen max-w-screen sm:bg-[#E7EEFA] items-start sm:items-center cursor-default">
      <div className="flex flex-col w-full sm:w-148 sm:bg-white min-h-screen sm:min-h-0 items-start sm:items-center rounded-xl sm:mt-24 p-4">
        <div className="w-full grid grid-cols-1 divide-y">
          <div className="mb-4">
            <KeyboardArrowLeftIcon
              className="absolute cursor-pointer "
              onClick={handleBack}
            />
            <div className="text-center font-semibold text-[#1F2328]">
              Activate Member Gateway Account
            </div>
          </div>
          <div>
            <div className="mt-3 text-xl font-semibold">
              Let's verify your mobile number
            </div>
            <div className="flex flex-row mt-1">
              <div className=" text-[#60656D]">
                Verify your account by entering the one-time password sent to
                {/* */}
                <span className="text-[#1F2328] font-semibold ml-1">
                  +63 {mobileNumber.charAt(0)}
                  {mobileNumber.substr(1, 5).replace(/./g, "*")}
                  {mobileNumber.substr(6, 9)}
                </span>
              </div>
            </div>
            <div className="mt-3">
              <OtpField
                value={otp}
                onChange={handleOtpChange}
                onSubmit={handleVerify}
                hasErrored={!displayAlert && alertMessage}
              />
              <span className="text-sm text-[#D32F2F]">
                {!displayAlert ? alertMessage : ""}
              </span>
            </div>
            <div className="flex flex-row mt-3">
              <div className="text-sm text-[#60656D]">
                Didn't get the password?{/* */}
                <button disabled={counter>0}
                  className={`ml-1 ${
                    counter === 0 && "cursor-pointer text-[#0947AB]"
                  }`}
                  onClick={counter === 0 ? resendOtp : null}
                  onKeyDown={(event) =>
                    handleKeyDown(event, () =>
                      counter === 0 ? resendOtp : null
                    )
                  }
                  tabIndex={0}
                >
                  {counter !== 0
                    ? `Resend (in ${formatTime(counter)})`
                    : "Resend OTP"}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="bg-white flex-grow" />
        <div className="flex flex-col sm:items-end items-center w-full">
          <Button
            disabled={otp.length < 6 || isLoading}
            className={`w-full h-12 mt-2  ${
              otp.length < 6 || isLoading
                ? `text-[#A3A7AB] bg-[#F6F7F7]`
                : `text-white`
            }`}
            onClick={handleVerify}
          >
            {isLoading ? <CircularProgress size={"1rem"} /> : "Verify"}
          </Button>
        </div>
      </div>
      <ErrorModal
        open={displayAlert}
        title={alertTitle}
        message={alertMessage}
        onClose={handleClose}
      />
      <ExpiredOtpModal
        open={showExpiredOtpModal}
        isLoading={isResending}
        onResend={handleResend}
        onCancel={handleCancelResend}
      />
    </div>
  );
}

export default ActivateVerifyOTP;
